export const messages = {
  comments: '评论',
  addComment: '写评论…',
  send: '发送',
  delete: '删除',
  empty: '暂无评论',
  vote: '投票',
  voted: '已投票',
  votes: '票'
} as const
